
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25.346 15.671l-4.81 6.12c-1.158 1.472-2.712 1.274-3.47-.437l-.28-.634.595 4.536h2.114c.279 0 .505.216.505.496v2.009a.5.5 0 01-.5.495h-17a.494.494 0 01-.5-.495v-2.01c0-.273.223-.495.505-.495h2.114l.595-4.536-1.008 2.624c-.198.517-.798 1.005-1.34 1.09l-.319.051c-.542.086-1.26-.19-1.605-.615l-.204-.252c-.345-.425-.466-1.183-.268-1.7l3.378-8.8c.395-1.028 1.62-1.862 2.713-1.862h8.878c1.103 0 2.321.844 2.716 1.872l1.353 3.524 2.68-3.43c.344-.44 1.059-.733 1.609-.656l.818.115 3.99-4.603c.18-.207.5-.222.702-.047.209.181.234.494.052.704l-4.013 4.63.243.602c.206.509.096 1.273-.243 1.704zm-10.242-.01a.345.345 0 01.35-.405c.169 0 .355.13.414.282l2.094 5.455c.357.93 1.143 1.047 1.755.264l4.787-6.126c.17-.218.224-.6.121-.854l-.06-.15a.95.95 0 00-.678-.53l-.16-.022c-.272-.038-.634.113-.797.322l-3.004 3.844-.718.92-1.996-5.2c-.255-.665-1.048-1.205-1.759-1.205H6.547c-.716 0-1.506.545-1.763 1.214L1.44 22.182c-.1.261-.042.646.13.86l.102.125a.95.95 0 00.803.308l.16-.026a.938.938 0 00.667-.537l2.828-7.367a.481.481 0 01.416-.289c.223 0 .381.174.35.405l-1.268 9.595h10.744l-1.268-9.595zM19 26.256v1H3v-1h16zm-8-16.5a4 4 0 100-8 4 4 0 000 8zm0-1a3 3 0 100-6 3 3 0 000 6z","fill":"#29757A"}})])
          )
        }
      }
    